import React from 'react';
import './index.scss';

const ScrollHint = ({ className }) => {
  return (
    <div className={`scroll-hint ${className}`}>
      <p className="text type-text -en -md">SCROLL</p>
    </div>
  )
}

export default ScrollHint;